const getSubscriptionInfo = (subscriptions?: string[]) => {
  if(!subscriptions)
    return undefined
  if(subscriptions?.includes("FBL_ENTERPRISE"))
    return {name: "Enterprise", rating: 3, isFblUser: false, redirectToFff: false}
  if(subscriptions?.includes("ENTERPRISE"))
    return {name: "Enterprise", rating: 3, isFblUser: false, redirectToFff: true}
  if(subscriptions?.includes("RECHNUNG"))
    return {name: "Rechnung", rating: 2, isFblUser: false, redirectToFff: true}
  if(subscriptions?.includes("FBL_FIBU"))
    return {name: "Fibu", rating: 2, isFblUser: false, redirectToFff: false}
  if(subscriptions?.includes("FBL_BASIS"))
    return {name: "Basis", rating: 1, isFblUser: true, redirectToFff: false}
  if(subscriptions?.includes("TEST"))
    return {name: "free", rating: 0, isFblUser: false, redirectToFff: true}
  if(subscriptions?.includes("FBL_FREE"))
    return {name: "free", rating: 0, isFblUser: true, redirectToFff: false}
  if(subscriptions?.includes("FREE"))
    return {name: "free", rating: 0, isFblUser: true, redirectToFff: true}
  
  return {name: "free", rating: 0, isFblUser: true, redirectToFff: true}
}

export default getSubscriptionInfo